import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { Toaster } from "sonner";
import Home from "@/pages/Home";
import QuizPage from "@/pages/QuizPage";
import AdminPage from "@/pages/AdminPage";
import ResetPage from "@/pages/ResetPage";
import CirclePage from "@/pages/CirclePage";
import ConditionPage, { ConditionsIndex } from "@/pages/ConditionPage";
import BlogPost, { BlogIndex } from "@/pages/BlogPage";
import QuizzesPage from "@/pages/QuizzesPage";
import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";
import AIChatWidget from "@/components/AIChatWidget";
import SimplePracticeLoader from "@/components/SimplePracticeLoader";
import MobileBookBar from "@/components/MobileBookBar";
import StructuredData from "@/components/StructuredData";

function Chrome() {
  const { pathname } = useLocation();
  const isAdmin = pathname.startsWith("/admin");
  return (
    <>
      {!isAdmin && <Navbar />}
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/quiz" element={<QuizPage />} />
        <Route path="/admin" element={<AdminPage />} />
        <Route path="/reset" element={<ResetPage />} />
        <Route path="/circle" element={<CirclePage />} />
        <Route path="/conditions" element={<ConditionsIndex />} />
        <Route path="/conditions/:slug" element={<ConditionPage />} />
        <Route path="/blog" element={<BlogIndex />} />
        <Route path="/blog/:slug" element={<BlogPost />} />
        <Route path="/quizzes" element={<QuizzesPage />} />
      </Routes>
      {!isAdmin && <Footer />}
      {!isAdmin && <AIChatWidget />}
      {!isAdmin && <MobileBookBar />}
      {!isAdmin && <StructuredData />}
      <SimplePracticeLoader />
    </>
  );
}

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Chrome />
        <Toaster
          position="bottom-left"
          toastOptions={{
            style: {
              background: "#F9F6F0",
              border: "1px solid #DCD7CB",
              color: "#2B2D27",
              fontFamily: "Work Sans, sans-serif",
            },
          }}
        />
      </BrowserRouter>
    </div>
  );
}

export default App;
